import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import AssemblyCountryHelpView from '../../../components/views/mx/seminuevos/AssemblyCountryHelpView';
import {State} from '../../../types/mx/reducers';

const mapStateToProps = (state: State) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {};
};

const AssemblyCountryHelpContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AssemblyCountryHelpView);

export default AssemblyCountryHelpContainer;
